window.gon = {
    config: {
        // Auth0 configuration values
        AUTH0_API_CLIENT_ID: 'dpm1UWlh4dK5J29LIPMvKHZY7VE6pn49',
        AUTH0_API_CLIENT_SECRET: '<%= decrypt "xroUYXw4w/93HOIAB7tzy59qFvxS7yHXdIJCiocysJpI2NkTm6OmRrePwQuXjN4Id6FT0aOxQNqr/OSbkQmO9YbSDzclmECUFqQIsrO30E4EcU8cv95Rhg==" %>',
        AUTH0_DOMAIN_URL: 'https://stg-patientfusion.auth0.com',
        PATIENT_PORTAL_AUTH0_CLIENT_ID: 'lZdeIGINDpvPfQKe026j8KTPPtBPu0z2',
        PHR_AUTH_TOKEN_KEY: 'phr_auth_token',

        // UI configuration values
        AGREEMENT_ENDPOINT_URL: 'https://stg-agreement-endpoint.patientfusion.com/api/v1',
        APPOINTMENT_ENDPOINT_URL: 'https://stg-appointment-endpoint.patientfusion.com',
        AUDITR_ENDPOINT_URL: 'https://stg-auditr-endpoint.patientfusion.com',
        BILLING_ENDPOINT_URL: 'https://stg-billing-endpoint.patientfusion.com',
        CCDA_ENDPOINT_URL: 'https://stg-ccda-endpoint.patientfusion.com',
        CLINICAL_ENDPOINT_URL: 'https://stg-clinical-endpoint.patientfusion.com/api/v1',
        DIRECT_ENDPOINT_URL: 'https://stg-api.practicefusion.com/direct/v1',
        INTAKE_ENDPOINT_URL: 'https://stg-intake.patientfusion.com/api/v1',
        MESSAGE_ENDPOINT_URL: 'https://stg-message-endpoint.patientfusion.com/api/v1',
        NOTIFICATION_ENDPOINT_URL: 'https://stg-notification-endpoint.patientfusion.com/api/v1',
        PATIENT_RECORD_ENDPOINT_URL: 'https://stg-patient-record-endpoint.patientfusion.com/api/v1',
        PHR_AUTHN_ENDPOINT_URL: 'https://stg-phr-authn-endpoint.patientfusion.com/api/v1',
        PHR_AUTHN_ENDPOINT_URL_V3: 'https://stg-phr-authn-endpoint.patientfusion.com/api/v3',
        PHR_HOME_URL: 'https://stg-my.patientfusion.com',
        PHR_PATIENT_ENDPOINT_URL: 'https://stg-phr-patient-endpoint.patientfusion.com/api/v2',

        PHR_USER_ENDPOINT_URL: 'https://stg-phr-user-endpoint.patientfusion.com/api/v2',
        PHR_USER_ENDPOINT_URL_v1: 'https://stg-phr-user-endpoint.patientfusion.com/api/v1',

        PRACTICE_ENDPOINT_URL: 'https://stg-practice-endpoint.patientfusion.com',
        SCHEDULE_AVAILABILITY_ENDPOINT_URL: 'https://stg-www.patientfusion.com/api/v1',
        TASK_ENDPOINT_URL: 'https://stg-task-endpoint.patientfusion.com',

        // Service configuration values
        INTAKE_URL: 'https://stg-intake.patientfusion.com',
        PF_LOGIN_URL : 'https://stg-login.patientfusion.com',
        PHR_AUTHN_FOUNDATION_URL: 'https://stg-phr-authn-foundation.patientfusion.net',
        PHR_SERVICES_HOST: 'https://stg-consumer.patientfusion.net/PhrServicesComposite',
        PHR_USER_DOMAIN_URL: 'https://stg-phr-user-domain.patientfusion.net',
        TASK_CREATION_URL: 'https://stg-my.patientfusion.com/register/task',
        TASK_DOMAIN_URL: 'https://stg-task-domain.patientfusion.net'
    },
    env: 'staging'
};